import React, { PureComponent } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { cssClasses } from '@douyinfe/semi-foundation/lib/es/form/constants';
const prefix = cssClasses.PREFIX;
export default class Section extends PureComponent {
  render() {
    const {
      text,
      className,
      style,
      children
    } = this.props;
    const cls = classNames({
      [prefix + '-section']: true
    }, className);
    const textCls = prefix + '-section-text';
    return /*#__PURE__*/React.createElement("section", {
      className: cls,
      style: style
    }, /*#__PURE__*/React.createElement("h5", {
      className: textCls
    }, text), children);
  }
}
Section.propTypes = {
  text: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node
};